import { render } from "./LeftSide.vue?vue&type=template&id=f3fb0e30&scoped=true"
const script = {}

import "./LeftSide.vue?vue&type=style&index=0&id=f3fb0e30&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3fb0e30"]])

export default __exports__